import React, { useState } from "react";
import { RxCaretDown } from "react-icons/rx";
import { useHandleClickOutside } from "../../shared/hook/useHandleClickOutside";

const InputDropdown = ({
  label,
  value,
  placeholder,
  list = [],
  name,
  updateForm,
  inputBg = "transparent",
  isShowing = true,
}) => {
  const { isOpen, setIsOpen, ref } = useHandleClickOutside();

  if (isShowing) {
    return (
      <div
        ref={ref}
        className="relative flex flex-col gap-2 font-unilever-shilling-normal text-[12px]"
      >
        <label className="my-0 font-unilever-shilling-normal text-[13px]">
          {label}*
        </label>
        <div
          style={{ backgroundColor: inputBg }}
          onClick={() => setIsOpen(true)}
          className="flex items-center justify-between !border !border-[#C8D3DE] p-2 cursor-pointer"
        >
          <span className="capitalize">{value || placeholder}</span>
          <RxCaretDown
            className={`w-5 h-5 transition-all ${isOpen ? "rotate-180" : ""}`}
          />
        </div>
        {isOpen && (
          <div className="absolute z-[999999] top-[70px] shadow left-0 bg-[#f7f8fc] max-h-[200px] overflow-y-auto w-full">
            {list.map((item, idx) => (
              <div
                key={idx}
                onClick={() => {
                  updateForm(name, item);
                  setIsOpen(false);
                }}
                className="px-2 py-3 transition-all hover:bg-[#f0f2f9] cursor-pointer"
              >
                {item}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  } else {
    return <></>;
  }
};

export default InputDropdown;
